import moment from 'moment-timezone';
import { decryptValue } from './common';
import { retry } from 'ckeditor5';

const userStorageKey = "user_info";
const defaultTimezone = 'Asia/Kolkata';

const setDataOnLocal = (data, key) => {
  const storageKey = key || userStorageKey;
  sessionStorage.setItem(storageKey, JSON.stringify(data));
};
const getDataOnLocal = (key) => {
  const storageKey = key || userStorageKey;
  const data = sessionStorage.getItem(storageKey);
  return data ? JSON.parse(data) : null;
};
const removeDataOnLocal = (key) => {
  const storageKey = key || userStorageKey;
  return sessionStorage.removeItem(storageKey);
};

// local storage
const setDataOnLocalstorage = (data, key) => {
  const storageKey = key || userStorageKey;
  localStorage.setItem(storageKey, JSON.stringify(data));
};
const getDataFromLocalstorage = (key) => {
  const storageKey = key || userStorageKey;
  const data = localStorage.getItem(storageKey);
  return data ? JSON.parse(data) : null;
};

const getLocalDataAsObject = (keyAsString) => {
  //  alert('getLocalDataAsObject=', keyAsString + '=' + localStorage.getItem(keyAsString))
  if (localStorage.getItem(keyAsString) !== undefined) {
      var objData = undefined;
      try {
          var data;
          if(keyAsString == 'user'){
            let encryptedData = localStorage.getItem(keyAsString);
              let encryptString= JSON.parse(encryptedData)
              data = decryptValue(encryptString);
          }else{
              data = localStorage.getItem(keyAsString);
          }
          if (typeof data !== "undefined" && data !== "undefined") {
              objData = JSON.parse(data);
          }
      } catch (error) {
      }
      return objData;
  }
}



const removeDataFromLocalstorage = (key) => {
  const storageKey = key || userStorageKey;
  return localStorage.removeItem(storageKey);
};

const convertToFile = (file, convertTo = "base64") => {
  return new Promise((resolve, reject) => {
    // Make new FileReader
    let reader = new FileReader();

    // Convert the file to base64 text
    reader.readAsDataURL(file);

    // on reader load somthing...
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
  });
};
const convertValue = (val, convertTo = "float") => {
  if (val) {
    if (convertTo === "float") return parseFloat(val, 10).toFixed(2);
  }
  return val;
};
const convertToDate = (dateTimestamp, format = 'DD/MM/YYYY') => { 
  return moment.tz(dateTimestamp, defaultTimezone).format(format);
};
const convertToTS = (dateTimestamp, format = 'DD/MM/YYYY') => { 

  return moment(dateTimestamp).format(format);
};

const subtractFromMomentDate = (date,addformat="YYYY-MM-DD", duration, unit, format="YYYY-MM-DD") => {   //subtractDate function
  return moment(date,addformat).subtract(duration, unit).format(format);
};

const addInMomentDate = (date,addformat="YYYY-MM-DD", duration, unit, format="YYYY-MM-DD") => {  //additionDate
  return moment(date,addformat).add(duration, unit).format(format) || "00:00:00";
};

const workHoursPercentages = (totalHour,time)=>{
    return (totalHour == "00:00:00" && time === "00:00:00") ? "00" : ((moment.duration(time,'HH:mm:ss').asSeconds() / moment.duration(totalHour,'HH:mm').asSeconds()) * 100).toFixed(2);
}

const currentDateAndTime = (format="YYYY-MM-DD")=>{
  return moment().format(format)
}

const convertShiftTime = (data)=>{
  return moment(data, 'HH:mm').format('hh:mm A')
}

//function to convert 'HH:MM:SS' to duration
const timeStringToDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr?.split(':').map(Number);
  return moment.duration({ hours, minutes, seconds });
};

const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (parts.length >= 3) {
    return parts[0];
  }
  return '';
};
export {
  setDataOnLocal,
  getDataOnLocal,
  removeDataOnLocal,
  convertToFile,
  convertValue,
  convertToDate,
  convertToTS,
  setDataOnLocalstorage,
  getDataFromLocalstorage,
  removeDataFromLocalstorage,
  getLocalDataAsObject,
  addInMomentDate,
  subtractFromMomentDate,
  workHoursPercentages,
  currentDateAndTime,
  timeStringToDuration,
  convertShiftTime,
  getSubdomain
};
